import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "DigitalDocumentSearchBox" })
export default class DigitalDocumentSearchBox extends Vue {
    public searchtext: string = null;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.searchtext = (<any>window).App.searchtext;
    }

    public search() {
        (<any>window).location = this.routes.DigitalDocument_List + "?searchtext=" + this.searchtext;
    }
};